import { callCurationProxy } from "../backend/backendClient";
import { parseJsonOrThrow, readTextOrThrow } from "./helpers";

/**
 * Publish or unpublish content panels
 * @param ids
 * @param publish
 * @returns {Promise<unknown>}
 */
const publishContentPanels = async (
    ids: (number | string)[],
    publish: boolean,
): Promise<unknown> => {
    const responseText = await readTextOrThrow(
        await callCurationProxy({
            path: "/list/contentpanels-publish",
            method: "PUT",
            body: { ids, publish, applyPublishStartTo: "all" },
        }),
        "Publish status (PUT)",
    );

    const trimmedResponse = responseText.trim();
    if (!trimmedResponse) {
        return null;
    }

    return parseJsonOrThrow<unknown>(trimmedResponse, "Publish content panels");
};

/**
 * setPublishStatus - Publish or unpublish a list or list items
 * @param listId
 * @param publish
 * @returns {Promise<unknown>}
 */
export const setPublishStatus = (listId: number | string, publish: boolean): Promise<unknown> => {
    const isValidNumberId = typeof listId === "number" && Number.isFinite(listId);
    const isValidStringId = typeof listId === "string" && Boolean(listId.trim());
    if (!isValidNumberId && !isValidStringId) {
        throw new Error("A valid listId is required to set the publish status.");
    }

    return publishContentPanels([listId], publish);
};

/**
 * setPublishStatusForItems - Publish or unpublish a list of list items
 * @param itemIds
 * @param publish
 * @returns {Promise<unknown>}
 */
export const setPublishStatusForItems = (itemIds: number[], publish: boolean): Promise<unknown> => {
    if (!itemIds || itemIds.length === 0) {
        throw new Error("setPublishStatusForItems requires an array of itemIds.");
    }

    return publishContentPanels(itemIds, publish);
};
